import * as React from 'react';
import {
  Button,
  Dimmer,
  Grid,
  Loader,
  Icon,
  Message
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Redirect, RouteComponentProps } from 'react-router';
import { UserForm } from 'components/user-form';
import { getI18n } from 'services/i18n-service';
import { Guid } from 'types/guid';
import { translations } from 'types/translations';
import { User } from 'types/user';
import { UserManagementMode } from 'types/user-management-mode';
import { Scrollable } from 'components/scrollable/component';

export interface UserManagementMatchParams {
  mode: UserManagementMode;
}

export interface UserManagementComponentProps {
  user?: User;
  errorMessage: string;
  isOnline: boolean;
  isProcessing: boolean;
  isLoadingUser: boolean;
  language: string;
  permissions: string;
  requestSuccess?: boolean;
}

export interface UserManagementActionProps {
  loadUser: (userId: Guid) => void;
  saveUser: (userId: Guid, user: User) => void;
  activateUser: (userId: Guid) => void;
  deactivateUser: (userId: Guid) => void;
  setBlankUser: () => void;
}

export type UserManagementProps = UserManagementComponentProps & UserManagementActionProps &
  RouteComponentProps<UserManagementMatchParams>;

export class UserManagement extends React.Component<UserManagementProps> {
  constructor(props: UserManagementProps) {
    super(props);
  }

  hasUserId = () => {
    return this.props.location && this.props.location.state && this.props.location.state.value;
  }

  getUserId = () => {
    return this.props.location && this.props.location.state.value;
  }

  componentWillMount() {
    if (this.hasUserId()) {
      if (this.props.isLoadingUser === false) {
        this.props.loadUser(this.getUserId());
      }
    } else if (this.isCreatingUser()) {
      this.props.setBlankUser();
    }
  }

  isCreatingUser = () => {
    return this.props.match && this.props.match.params && this.props.match.params.mode === UserManagementMode.create;
  }

  activateUser = () => {
    if (this.props.user) {
      this.props.activateUser(this.props.user.id);
    } else {
      throw Error('Cannot activate user. User is not defined');
    }
  }

  deactivateUser = () => {
    if (this.props.user) {
      this.props.deactivateUser(this.props.user.id);
    } else {
      throw Error('Cannot deactivate user. User is not defined');
    }
  }

  generateActivationSection = () => {
    const i18n = getI18n();
    if (!this.props.user || this.props.isLoadingUser) {
      return null;
    }

    const isActive = this.props.user.isActive;

    return (
      <Button className="ui neutral"
        color={isActive ? 'red' : 'green'}
        content={i18n.t(isActive ? translations.DeactivateUser : translations.ActivateUser)}
        disabled={!this.props.isOnline || this.props.isProcessing}
        onClick={isActive ? this.deactivateUser : this.activateUser} />
    );
  }

  public render() {
    if (!this.hasUserId() && !this.isCreatingUser()) {
      return (<Redirect to={`${process.env.PUBLIC_URL}/users`} />);
    }

    const i18n = getI18n();
    return (
      <Scrollable>
        <Dimmer.Dimmable>
          <Dimmer active={this.props.isProcessing}>
            <Loader />
          </Dimmer>
          <Grid columns={1} padded="horizontally" className="form-page user-management-page">
            <Grid.Row>
              <Grid.Column width={16} className="padding-right">
                <Grid className="panel">
                  <Grid.Row>
                    <Grid.Column computer={10} mobile={16}>
                      <Link className="ui neutral" to={`${process.env.PUBLIC_URL}/users`}>
                        <Icon name="arrow left" />
                        {i18n.t(translations.Back)}
                      </Link>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column computer={10} mobile={16}>
                      {
                        this.isCreatingUser() ?
                          <Message color="yellow" size="tiny">
                            <Message.Content>
                              <Icon className="warning" name="warning sign" />
                              {i18n.t(translations.UserInfoWarning)}
                            </Message.Content>
                          </Message>
                          :
                          null
                      }
                      <UserForm
                        isProcessing={this.props.isProcessing}
                        isFirstLoading={this.props.isLoadingUser}
                        user={this.props.user}
                        errorMessage={this.props.errorMessage}
                        saveUser={this.props.saveUser}
                        mode={this.props.match.params.mode}
                        requestSuccess={this.props.requestSuccess}
                      >
                        {this.generateActivationSection()}
                      </UserForm>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid >
        </Dimmer.Dimmable>
      </Scrollable>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/user-management/component.tsx